package fr.frux.shared.data.local

import dev.zacsweers.metro.ContributesTo
import dev.zacsweers.metro.Provider
import dev.zacsweers.metro.Provides
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.di.AppScope
import fr.frux.core.database.FruxDatabase
import fr.frux.core.database.localDatabaseSupported
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

/**
 * Fourniture du cache local des arbres (#60). La base arrive en [Provider] et n'est déréférencée
 * que si la cible a un driver SQLite : sur web (js), `createDatabaseDriver` lève (#59) et le
 * graphe retombe sur [NoOpTreeLocalDataSource] — comportement réseau seul, sans stockage.
 */
@ContributesTo(AppScope::class)
interface TreeLocalDataSourceModule {
    companion object {
        /** Politique par défaut (#62) : fournie ici pour rester configurable sans toucher au datasource. */
        @Provides
        @SingleIn(AppScope::class)
        fun provideTreeCachePolicy(): TreeCachePolicy = TreeCachePolicy()

        @OptIn(ExperimentalTime::class)
        @Provides
        @SingleIn(AppScope::class)
        fun provideTreeLocalDataSource(
            database: Provider<FruxDatabase>,
            policy: TreeCachePolicy,
        ): TreeLocalDataSource =
            if (localDatabaseSupported) {
                SqlDelightTreeLocalDataSource(database(), policy) { Clock.System.now().toEpochMilliseconds() }
            } else {
                NoOpTreeLocalDataSource
            }
    }
}
